import { useState, useEffect, useCallback } from 'react';

export function useScrollDirection() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const controlHeader = useCallback(() => {
    const SCROLL_THRESHOLD = 40; // スクロールの閾値
    const currentScrollY = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // スクロール可能な量を計算
    const scrollableHeight = documentHeight - windowHeight;

    // スクロール可能な量が閾値以下の場合はヘッダーを非表示にしない
    if (scrollableHeight <= SCROLL_THRESHOLD) {
      setIsVisible(true);
      return;
    }

    // 画面最上部での制御
    if (currentScrollY <= 0) {
      setIsVisible(true);
      setLastScrollY(0);
      return;
    }

    // 画面最下部での制御
    if (currentScrollY + windowHeight >= documentHeight - 10) {
      // 余裕を持たせる
      setIsVisible(false);
      setLastScrollY(currentScrollY);
      return;
    }

    // 通常のスクロール制御
    // より大きな移動量が必要な場合のみヘッダー状態を変更
    const scrollDelta = Math.abs(currentScrollY - lastScrollY);

    if (scrollDelta > SCROLL_THRESHOLD) {
      if (currentScrollY > lastScrollY) {
        // 下スクロール
        setIsVisible(false);
      } else {
        // 上スクロール
        setIsVisible(true);
      }
      // 現在のスクロール位置を保存
      setLastScrollY(currentScrollY);
    }
  }, [lastScrollY]);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const debounceScroll = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(controlHeader, 10);
    };

    window.addEventListener('scroll', debounceScroll);

    return () => {
      window.removeEventListener('scroll', debounceScroll);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [controlHeader]);

  return isVisible;
}
